import React, { useEffect, useCallback, useState } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Spin, Drawer, ConfigProvider, Button } from 'antd';
import { post } from '../../../../../axios/axios';
import closeIcon from '../../images/icon_close.svg';

// 扩写
const ExpansionModal = NiceModal.create(({ orderNo, content, from, to, chapterId }) => {
    const modal = useModal();
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const handleOk = () => {
        modal.resolve(replaceText(text));
        modal.hide();
    };

    const handleReset = () => {
        fetchData();
    };

    const replaceText = useCallback((text) => {
        return text.replace(/\[\[citation:(\d+)\]\]/g, (match, num) => `<sup>[${num}]</sup>`);
    }, []);

    const fetchData = useCallback(async () => {
        if (!orderNo || !chapterId || !content) return;
        try {
            setLoading(true);
            const res = await post('/ai/ai/paper/editor/expand', {
                orderNo,
                chapterId,
                original: content,
            });
            console.log('res', res);
            setText(res.data);
        } catch (error) {
            console.error('Error fetching content reduction:', error);
        } finally {
            setLoading(false);
        }
    }, [orderNo, chapterId, content]); // 这些依赖是必要的

    useEffect(() => {
        if (!modal.visible) return;
        fetchData();
    }, [modal.visible, fetchData]);

    return (
        <>
            <ConfigProvider
                theme={{
                    token: {
                        colorBgMask: 'rgba(0, 0, 0, 0.01)',
                    },
                }}
            >
                <Drawer
                    title="扩写"
                    placement="right"
                    mask={true}
                    maskClosable={true}
                    open={modal.visible}
                    closeIcon={null}
                    destroyOnClose={true}
                    headerStyle={{ borderBottom: 'none' }}
                    bodyStyle={{ padding: '0 24px' }}
                    onClose={() => setShowConfirm(true)}
                    extra={
                        <img
                            className="block h-4 w-4 cursor-pointer"
                            src={closeIcon}
                            onClick={() => setShowConfirm(true)}
                            alt=""
                        />
                    }
                >
                    <div style={{ width: '552px' }}>
                        {/* 原文 */}
                        <div
                            className="w-full rounded-md p-3"
                            style={{
                                background: '#F8FBFF',
                                border: '1px solid #EEEEF1',
                            }}
                        >
                            <div
                                className="title text-base font-medium"
                                style={{ color: '#192038' }}
                            >
                                原文
                            </div>
                            <div
                                className="content mt-4 max-h-[110px] overflow-y-auto text-sm"
                                style={{ lineHeight: '22px' }}
                            >
                                {content}
                            </div>
                        </div>

                        {/* 扩写结果 */}
                        {loading ? (
                            <div className="flex h-32 items-center justify-center">
                                <Spin />
                            </div>
                        ) : (
                            <div className="mt-4">
                                <div
                                    className="w-full rounded-md p-3"
                                    style={{
                                        background: '#ffffff',
                                        border: '1px solid #9557FF',
                                    }}
                                >
                                    <div
                                        className="title text-base font-medium"
                                        style={{ color: '#192038' }}
                                    >
                                        扩写结果
                                    </div>
                                    <div
                                        className="content mt-4 max-h-[110px] overflow-y-auto text-sm"
                                        style={{ lineHeight: '22px' }}
                                        dangerouslySetInnerHTML={{ __html: replaceText(text) }}
                                    />
                                </div>
                            </div>
                        )}

                        {/* 底部按钮 */}
                        <div className="btns mt-8 flex items-center justify-center">
                            <Button type="primary" onClick={handleOk}>
                                替换原文
                            </Button>
                            <Button
                                className="ml-2"
                                onClick={handleReset}
                                style={{ background: '#F8FBFF' }}
                            >
                                重新生成
                            </Button>
                        </div>
                    </div>
                </Drawer>
            </ConfigProvider>

            {/* 关闭确认弹窗 */}
            <Modal
                zIndex={100000}
                title="确认关闭"
                destroyOnClose={true}
                open={showConfirm}
                onOk={() => {
                    setShowConfirm(false);
                    modal.reject();
                    modal.hide();
                }}
                onCancel={() => setShowConfirm(false)}
                okText="确认"
                cancelText="取消"
            >
                <p>确定要关闭当前窗口吗？</p>
            </Modal>
        </>
    );
});

export default ExpansionModal;
